import React, { useCallback, useState } from 'react';
import { Column } from 'primereact/column';
import { DataTablePageParams } from 'primereact/datatable';
import Table from '../../../../components/Table/Table';
import { formatUTCDate } from '../../../../../utils/formatUtils';
import { FormHistoryItem } from '../../../../Interfaces/Accounting/ACForms.interfaces';
import { stateLabel } from './ContractDrilldownData';
import ContractHistoryDrilldownContainer from './ContractHistoryDrilldownContainer';
import { ContractHistorySummaryDTO } from '@/src/app/Interfaces/Accounting/ContractBillings.interface';

type JobSetupInfoTableProps = {
  contracts: ContractHistorySummaryDTO[];
  total: number;
  page: number;
  rows: number;
  onPageChange: (page: number, rows: number) => void;
};

const JobSetupInfoTable = ({
  contracts,
  total,
  page,
  rows,
  onPageChange,
}: JobSetupInfoTableProps) => {
  const [selectedContract, setSelectedContract] =
    useState<ContractHistorySummaryDTO | null>(null);

  const calcHeight = useCallback((rowCount: number) => {
    return 32 + rowCount * 31 + 3;
  }, []);

  return (
    <React.Fragment>
      {selectedContract && (
        <ContractHistoryDrilldownContainer
          contract={selectedContract}
          onHide={() => setSelectedContract(null)}
        />
      )}
      <Table
        data={contracts}
        className="dashboardOptionShadow noFooter mx-3"
        calcHeight={calcHeight}
        paginator
        lazy
        totalRecords={total}
        rows={rows}
        first={page * rows}
        onPage={(e: DataTablePageParams) =>
          onPageChange(Math.floor(e.first / e.rows), e.rows)
        }
        onRowClick={(e) => setSelectedContract(e.data)}
        rowClass={() => 'cursor-pointer'}
      >
        <Column
          field="contract"
          header="Contract #"
          style={{ minWidth: '110px' }}
          headerClassName="tableHeader font-normal"
          className="justify-content-center text-standard blackText tableCell"
          footerClassName="tableFooter"
        />
        <Column
          field="name"
          header="Contract Name"
          body={(contract) => {
            return <div className="scroll-text">{contract.name}</div>;
          }}
          style={{ minWidth: '210px', maxWidth: '210px' }}
          headerClassName="tableHeader font-normal justify-content-center"
          className="text-standard blackText tableCell overflow-x-hidden white-space-nowrap checkOverflow"
          footerClassName="tableFooter"
        />
        <Column
          field="state"
          header="Status"
          body={(contract) => stateLabel[contract.state] ?? contract.state}
          style={{ minWidth: '210px', maxWidth: '210px' }}
          headerClassName="tableHeader font-normal"
          className="text-standard blackText tableCell overflow-x-hidden white-space-nowrap checkOverflow justify-content-center"
          footerClassName="tableFooter"
        />
        <Column
          field="updatedAt"
          header="Submitted At"
          body={(item: FormHistoryItem) => formatUTCDate(item.updatedAt)}
          style={{ minWidth: '70px' }}
          headerClassName="tableHeader font-normal text-center"
          className="text-standard blackText tableCell justify-content-center"
        />
        <Column
          field="user.name"
          header="Submitted By"
          body={(item: FormHistoryItem) =>
            `${item.user.firstName} ${item.user.lastName}`
          }
          style={{ minWidth: '225px' }}
          headerClassName="tableHeader font-normal"
          className="text-standard blackText tableCell justify-content-center text-center"
        />
      </Table>
    </React.Fragment>
  );
};

export default JobSetupInfoTable;
